// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "relative-import-" + {"1786":"summaryStats.worker","1974":"summaryUserCache.worker","8335":"summarySlotCache.worker"}[chunkId] + "." + {"1786":"0167f3c1764d9694d333","1974":"79cb50883d960fe1742a","8335":"fc48828f1a0138f0a552"}[chunkId] + ".js";
};